import React from 'react';
import { View } from 'react-native';

import { QuickActionMenu, VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import BillingTestKeys from '../../Utils/BillingTestKeys.js';

import styles from './MonthlyBillingQAM.Styles';

const MonthlyBillingQAM = ({
  isVisible,
  title,
  QAModalTitle,
  QAModalDesc,
  toggleModal,
  closeModal,
}) => {
  return (
    <QuickActionMenu
      isVisible={isVisible}
      toggleModal={toggleModal}
      closeModal={closeModal}
      title={title}
      type="secondary"
      headerStyle={styles.QAheader}
      closeIconAccessibilityLabel="CloseIcon"
      testID={BillingTestKeys.monthlyBillingQAM}
    >
      <View style={styles.QAcontainer} testID={BillingTestKeys.monthlyBillingQAMView}>
        <VFText
          i18nKey={QAModalTitle}
          type="primary"
          style={styles.QAtitle}
          testKey={BillingTestKeys.monthlyBillingQAMTitleText}
        />
        {QAModalDesc}
        <VFButton
          title={'Close'}
          onPress={closeModal}
          type="secondary"
          style={styles.QAbutton}
          testKey={BillingTestKeys.monthlyBillingQAMCloseBTN}
        />
      </View>
    </QuickActionMenu>
  );
};

MonthlyBillingQAM.defaultProps = {
  theme: LightThemeColors,
};

MonthlyBillingQAM.propTypes = {
  isVisible: PropTypes.string,
  title: PropTypes.string,
  QAModalTitle: PropTypes.string,
  QAModalDesc: React.ReactNode,
  toggleModal: PropTypes.func,
  closeModal: PropTypes.func,
};

export default withTheme(MonthlyBillingQAM);
